import React from 'react'
import styles from './InviteFriendsDialog.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {apiv3} from 'lib/apiv3'
import {getCurrentUser} from 'lib/utils'
import {FormSubmitHack} from 'common/FormSubmitHack'
import fetchJSON from 'lib/fetchJSON'
import {infoMessage, errorMessage} from 'lib/styleguide/base.scss'

export const INVITE_FRIENDS_DIALOG = 'INVITE_FRIENDS_DIALOG'

export class InviteFriendsDialog extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      recentTrips: null,
      info: null,
      error: null,
      tripId: null,
      email: null
    }
  }

  componentDidMount () {
    this.preloadNonRenderBlockingData()
  }

  preloadNonRenderBlockingData = () => apiv3.search({
    userId: getCurrentUser().id,
    sortBy: 'created DESC',
    limit: 5,
    types: ['trips']
  }).then(res => {
    let recentTrips = res.results.map((v) => [v.get('id'), v.get('name')])
    this.setState({recentTrips: recentTrips})
  })

  onTripSelectChange = (e) => {
    this.setState({tripId: parseInt(e.target.value, 10)})
  }

  onEmailChange = (e) => {
    this.setState({email: e.target.value})
  }

  submitForm = (e) => {
    e && e.preventDefault()
    const {tripId, email, recentTrips} = this.state
    const missing = recentTrips.map(([k, _]) => (k)).indexOf(tripId) === -1 || email.length === 0

    if (missing) {
      this.setState({error: 'Please choose a trip and include a valid email address'})
    } else {
      fetchJSON('/referrals', {trip_id: tripId, email: email})
        .then((res) => {
          this.setState({info: res.meta.message, error: null})
        })
        .catch((res) => {
          this.setState({info: null, error: res.error})
        })
    }
  }

  render () {
    const {recentTrips, info, error} = this.state
    const {onRequestClose} = this.props

    return (
      <ModalOverlay maxWidth={'600px'} onRequestClose={onRequestClose}>
        <div className={styles.inner}>
          <FormSubmitHack />
          {error && <p className={errorMessage}>{error}</p>}
          {info && <p className={infoMessage}>{info}</p>}
          <h2 className={styles.header}>Recommend this site</h2>
          <div className={styles.text}>
            We will send one email inviting your friend(s) to try out Ride
            with GPS. This is a one time email; email addresses are not kept on
            file.
          </div>
          <div className={styles.text}>
            If a friend you invited joins Ride with GPS and uses their
            account to plan or record an activity, you will receive a one month
            free premium subscription!
          </div>
          <form id='invite' onSubmit={this.submitForm}>
            <label>Share a recent trip with your friend(s) to show them what we're all about!</label>
            <select id='tripId' name='trip_id' onChange={this.onTripSelectChange}>
              <option value='' disabled selected>Select trip</option>
              {recentTrips && recentTrips.map(([k, v]) => (<option key={k} value={k}>{v}</option>))}
            </select>
            <label>Enter an email address below to send an invitation.</label>
            <input id='email' type='text' placeholder='friend@domain.com' onChange={this.onEmailChange} />
          </form>
          <CTA button type='submit' onClick={this.submitForm}>Send Invitation</CTA>
        </div>
      </ModalOverlay>
    )
  }
}
